import isFunction from 'lodash/isFunction'
import React from 'react'

export const HideIf = ({ condition, children }: { condition: any; children: any }) => {
  //check if is the condition is a function or just a boolean value
  if (isFunction(condition)) {
    //just execute it and overwrite the existing value
    condition = condition()
  }

  const style = condition ? { display: 'none' } : { display: 'block' }

  return <div style={style}>{children}</div>
}
